import { FIXED_INDENTS } from 'vars/index'

export const DropdownAlignment = {
  Left: 'left',
  Right: 'right',
} as const
export type DropdownAlignment =
  (typeof DropdownAlignment)[keyof typeof DropdownAlignment]

type RowGapKey = 'SIZE_0' | 'SIZE_20'
export const DropdownRowGaps: Record<RowGapKey, readonly [string]> = {
  SIZE_0: [FIXED_INDENTS.INDENT_0],
  SIZE_20: [FIXED_INDENTS.INDENT_20],
} as const
export type DropdownRowGap =
  (typeof DropdownRowGaps)[keyof typeof DropdownRowGaps]

export const DropdownPosition = {
  Top: 'top',
  Bottom: 'bottom',
} as const
export type DropdownPosition =
  (typeof DropdownPosition)[keyof typeof DropdownPosition]
